import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useOpenableControls } from '../../../../generic-hooks'
import { useGlobalConfigContext } from '../../../../global-config'
import { IconCircleInfoFilled } from '../../../../icons'
import { ProductPrescriptionDialog } from '../../../../product'
import { TENANT } from '../../../../tenant'

import { ProductSearchResultItemGenericLabel } from './ProductSearchResultItemGenericLabel'

export const ProductSearchResultItemPrescriptionRequiredLabel: FC = () => {
  const modalControls = useOpenableControls()
  const { tenant } = useGlobalConfigContext()
  // Modal not needed for CH as users will be redirected to Mediservice to buy Rx products
  const withModal = tenant !== TENANT.CH

  return (
    <>
      <ProductSearchResultItemGenericLabel
        className="border-dark-brand bg-light-secondary-medium capitalize"
        hasBorder={false}
        onClick={withModal ? modalControls.handleOpen : undefined}
        type="button"
      >
        <FormattedMessage id="prescription.labels.prescriptionRequired" />
        {withModal ? <IconCircleInfoFilled className="ml-2 size-4" /> : null}
      </ProductSearchResultItemGenericLabel>
      {withModal ? (
        <ProductPrescriptionDialog
          isOpen={modalControls.isOpen}
          onClose={modalControls.handleClose}
        />
      ) : null}
    </>
  )
}
